export const NotePreview = ({ htmlContent, onDownload }) => {
  if (!htmlContent) return null;

  return (
    <div className="w-full max-w-4xl mx-auto bg-white shadow-md border-t-4 border-idc-red">
      <div className="flex justify-between items-center px-8 py-5 bg-white border-b border-idc-border">
        <h2 className="text-xl font-bold text-idc-dark tracking-tight">
          Vista Previa del Documento
        </h2>
        <button 
          onClick={onDownload} 
          className="flex items-center gap-2 px-5 py-2.5 bg-[#2e7d32] hover:bg-[#1b5e20] text-white text-sm font-semibold rounded"
        >
          Descargar HTML
        </button>
      </div>
      
      {/* Contenedor del contenido */}
      <div 
        className="p-8 text-idc-dark leading-relaxed text-base"
        dangerouslySetInnerHTML={{ __html: htmlContent }} 
      />
    </div>
  );
};